module.exports = __webpack_public_path__ + "img/myCall.a8596be5.png";